export default "__VITE_ASSET__BA9kT6AI__"